import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import DanhSachCuaHangApi from "service/danhSachCuaHangApi";
import DanhSachNhanVienApi from "service/danhSachNhanVienApi";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { formatDayMonth } from "utils/formatDate";
import { convertDate } from "utils/formatDate";
import { currentDate } from "utils/formatDate";
import { pushNotification } from "utils/notifications";
import { useSelector } from "react-redux";
import Select from "react-select";
import CauHinhApi from "service/cauHinhApi";
import cauHinh from "utils/cauHinh";

export const ShowNhanVien = (props) => {
  const [isDaCuaHang, setIsDaCuaHang] = useState(false);
  const [dataAddAndEditNew, setDataAddAndEdit] = useState({});
  const [loading, setLoading] = useState(true);
  const [dataCuaHang, setdataCuaHang] = useState([]);
  const [dataRoles, setdataRoles] = useState([]);
  const [isDisable, setIsDisable] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [selectedCuaHang, setSelectedCuaHang] = useState(null);
  const [lstCuaHang, setLstCuaHang] = useState(false);
  const [cuaHangIds, SetCuaHangIds] = useState([]);

  useEffect(() => {
    if (loading) {
      loadCuaHang();
      loadRoles();
      if (props.data != undefined && props.data.Email) {
        setDataAddAndEdit(props.data);
        if (props.data.CuaHangIds) SetCuaHangIds(props.data.CuaHangIds);
        console.log("props.data", props.data);
        setIsEdit(true);
      } else {
      }
      CauHinhApi.getConfigSys1().then((response) => {
        if (response.status === 200) {
          if (response.data.length > 0) {
            const isPhanQuyenNhieuCuaHang = response.data.find(
              (e) => e.keyConfig === "isPhanQuyenNhieuCuaHang"
            );
            if (isPhanQuyenNhieuCuaHang != null) {
              if (isPhanQuyenNhieuCuaHang.valueConfig === "1") {
                setIsDaCuaHang(true);
              }
            }
          }
          console.log("isPhanQuyenNhieuCuaHang", isDaCuaHang);
        }
      });
      setLoading(false);
    }
  }, []);

  const handleChange = (selectedOption) => {
    setSelectedCuaHang(selectedOption);
  };

  const onChangeDate = (field) => (value) => {
    const data = { ...dataAddAndEditNew };
    data[field] = formatDayMonth(value);
    setDataAddAndEdit(data);
  };

  const updateTextValue = (field) => (e) => {
    const data = { ...dataAddAndEditNew };
    console.log("e.target.value", e);
    data[field] = e.target.value;
    setDataAddAndEdit(data);
  };

  const loadRoles = () => {
    DanhSachNhanVienApi.roles().then((response) => {
      if (response.status == "200") {
        setdataRoles(response.data.Roles);
      }
    });
  };

  const loadCuaHang = async () => {
    try {
      setLoading(true);
      let data = {
        sCode: "",
        sName: "",
        sAddress: "",
        sPhone: "",
        sStatus: "",
        pageIndex: 1,
        pageSize: 20,
      };
      const res = await DanhSachCuaHangApi.list(data);
      // setdataResponse(res.data || []);
      var lstUser = res.data.List.map((item) => ({
        value: item.CompanyID,
        label: item.Name,
      }));
      setLstCuaHang(lstUser);
      console.log("dataCuaHang", lstUser);
      setdataCuaHang(res.data.List);
      // setdataResponse(res.data || []);
      if (props.data != undefined && props.data.Email) {
        if (props.data.CuaHangIds) {
          var lstUserSelected = res.data.List.filter((item) =>
            props.data.CuaHangIds.includes(item.CompanyID)
          ).map((item) => ({
            value: item.CompanyID,
            label: item.Name,
          }));
          setSelectedCuaHang(lstUserSelected);
        }
      }

      // setSelectedCuaHang(lstUser);
      // setListNVKDNew(a);
    } catch (error) {
      console.error("Lỗi load danh sách cửa hàng:", error);
    } finally {
      setLoading(false);
    }
  };

  const addOrEdit = () => {
    const data = { ...dataAddAndEditNew };
    if (isEdit) data.IsEdit = true;
    if (selectedCuaHang) {
      const lstCuaHang = selectedCuaHang.map((x) => x.value);
      console.log("selectedCuaHang", lstCuaHang);
      data["CuaHangIds"] = lstCuaHang;
    }
    data["Role"] = data.Role ?? (dataRoles.length > 0 ? dataRoles[0].ID : "");
    data["CuaHangId"] =
      data.CuaHangId ??
      (dataCuaHang.length > 0 ? dataCuaHang[0].CompanyID : "");
    data["GioiTinh"] = data.GioiTinh ?? 1;

    setDataAddAndEdit(data);
    console.log("dataAddAndEditNewdataAddAndEditNewdataAddAndEditNew", data);
    DanhSachNhanVienApi.luuNhanVien(data).then((response) => {
      console.log("reponsereponsereponsereponsereponse", response);
      if (response.data.Error == 0) {
        pushNotification(response.data.Message, "success", "TOP_CENTER", 1000);
        setIsDisable(true);
        props.onSearch();
      } else
        pushNotification(response.data.Message, "error", "TOP_CENTER", 1000);
    });
  };

  return (
    <Modal
      {...props}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 class="modal-title color7-bold" id="myModalLabel16">
          <span class="btn-icon-right">
            <img src="/app-assets/images/icon-donglai.png" alt="" />
          </span>
          &nbsp; {isEdit ? "Cập nhật" : "Thêm mới"}
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <i class="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form class="form tat-toan form-horizontal ">
          <div class="form-body">
            <div class="card collapse-icon accordion-icon-rotate">
              <div
                id="headingCollapse253"
                class="card-header border-info"
                href="#collapse253"
                aria-expanded="true"
                aria-controls="collapse253"
              >
                <a href={() => false} class="card-title lead info collapsed">
                  <h3>Tài khoản đăng nhập</h3>
                </a>
              </div>
              <div
                id="collapse253"
                aria-labelledby="headingCollapse253"
                class="card-collapse collapse show"
                aria-expanded="true"
              >
                <div class="card-content">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-3">
                        <label className="label-control color7-bold">
                          Email đăng nhập{" "}
                          <span className="canh-bao-red">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control input-sm"
                          value={dataAddAndEditNew.Email}
                          onChange={updateTextValue("Email")}
                          readOnly={isEdit}
                        />
                      </div>

                      <div class="col-md-3">
                        <label className="label-control color7-bold">
                          Tài khoản <span className="canh-bao-red">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control input-sm"
                          value={dataAddAndEditNew.TenDangNhap}
                          onChange={updateTextValue("TenDangNhap")}
                          readOnly={isEdit}
                        />
                      </div>

                      <div className="col-md-3">
                        <div className="form-group position-relative">
                          <label className="label-control color7-bold">
                            Mật khẩu
                          </label>
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control input-sm pr-5"
                            value={dataAddAndEditNew.MatKhau || ""}
                            onChange={updateTextValue("MatKhau")}
                          />
                          <i
                            className={`mdi ${
                              showPassword ? "mdi-eye-off" : "mdi-eye"
                            } password-toggle-icon`}
                            onClick={() => setShowPassword(!showPassword)}
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "35px",
                              cursor: "pointer",
                              color: "#888",
                            }}
                          ></i>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="form-group position-relative">
                          <label className="label-control color7-bold">
                            Xác nhận mật khẩu
                          </label>
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control input-sm pr-5"
                            value={dataAddAndEditNew.MatKhau_XM || ""}
                            onChange={updateTextValue("MatKhau_XM")}
                          />
                          {/* <i
                            className={`mdi ${
                              showPassword ? "mdi-eye-off" : "mdi-eye"
                            } password-toggle-icon`}
                            onClick={() => setShowPassword(!showPassword)}
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "35px",
                              cursor: "pointer",
                              color: "#888",
                            }}
                          ></i> */}
                        </div>
                      </div>
                      {!isEdit && (
                        <div class="col-md-3">
                          <div class="form-group">
                            <label className="color7-bold">Quyền</label>
                            <select
                              class="selectBox form-control input-sm"
                              value={dataAddAndEditNew.Role}
                              onChange={updateTextValue("Role")}
                            >
                              {dataRoles.map((item, idx) => (
                                <option key={"combo" + idx} value={item.ID}>
                                  {item.Values}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      )}
                      {!isDaCuaHang && (
                        <div class="col-md-3">
                          <div class="form-group">
                            <label className="color7-bold">Cửa hàng</label>
                            <select
                              class="selectBox form-control input-sm"
                              value={dataAddAndEditNew.CuaHangId}
                              onChange={updateTextValue("CuaHangId")}
                            >
                              {dataCuaHang.map((item, idx) => (
                                <option
                                  key={"combo" + idx}
                                  value={item.CompanyID}
                                >
                                  {item.Name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      )}

                      {isDaCuaHang && (
                        <div className="col-md-6">
                          <label className="color7-bold">Cửa hàng</label>
                          <Select
                            value={selectedCuaHang}
                            onChange={handleChange}
                            options={lstCuaHang}
                            isMulti={true}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div
                id="headingCollapse553"
                class="card-header border-info mt-1"
                href="#collapse553"
                aria-expanded="true"
                aria-controls="collapse553"
              >
                <a href={() => false} class="card-title lead info collapsed">
                  <h3>Thông tin cá nhân</h3>
                </a>
              </div>
              <div
                id="collapse553"
                aria-labelledby="headingCollapse553"
                class="card-collapse collapse show"
                aria-expanded="true"
              >
                <div class="card-content">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-3">
                        <label className="label-control color7-bold">
                          Họ Tên <span className="canh-bao-red">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control input-sm"
                          value={dataAddAndEditNew.HoTen}
                          onChange={updateTextValue("HoTen")}
                        />
                      </div>

                      <div class="col-md-3">
                        <div class="form-group">
                          <label className="color7-bold">Giới tính</label>
                          <select
                            class="selectBox form-control input-sm"
                            value={dataAddAndEditNew.GioiTinh}
                            onChange={updateTextValue("GioiTinh")}
                          >
                            <option value="1">Nam</option>
                            <option value="2">Nữ</option>
                          </select>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="form-group">
                          <label className="color7-bold">
                            Ngày sinh <span className="canh-bao-red">*</span>
                          </label>
                          <DateTimePicker
                            name="Ngày sinh"
                            onChange={onChangeDate("NgaySinh")}
                            value={convertDate(dataAddAndEditNew.NgaySinh)}
                            placeholder="dd/mm/yyyy"
                            customInput={
                              <input
                                name="Birthday"
                                placeholder="dd/mm/yyyy"
                              ></input>
                            }
                          ></DateTimePicker>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <label className="label-control color7-bold">
                          Số CCCD
                        </label>
                        <input
                          type="text"
                          className="form-control input-sm"
                          value={dataAddAndEditNew.CCCD}
                          onChange={updateTextValue("CCCD")}
                        />
                      </div>

                      <div class="col-md-3">
                        <label className="label-control color7-bold">
                          Địa chỉ
                        </label>
                        <input
                          type="text"
                          className="form-control input-sm"
                          value={dataAddAndEditNew.DiaChi}
                          onChange={updateTextValue("DiaChi")}
                        />
                      </div>

                      <div class="col-md-3">
                        <label className="label-control color7-bold">
                          Số điện thoại <span className="canh-bao-red">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control input-sm"
                          value={dataAddAndEditNew.SDT}
                          onChange={updateTextValue("SDT")}
                        />
                      </div>

                      <div class="col-md-3">
                        <label className="label-control color7-bold">
                          Email cá nhân
                        </label>
                        <input
                          type="text"
                          className="form-control input-sm"
                          value={dataAddAndEditNew.Email_CN}
                          onChange={updateTextValue("Email_CN")}
                        />
                      </div>

                      <div class="col-md-3">
                        <label className="label-control color7-bold">
                          Mã nhân viên
                        </label>
                        <input
                          type="text"
                          className="form-control input-sm"
                          value={dataAddAndEditNew.MaNV}
                          onChange={updateTextValue("MaNV")}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
        <button
          className="btn btn-new-main btn-checknew"
          onClick={addOrEdit}
          disabled={isDisable}
        >
          <span>
            <i class="mdi mdi-check"></i>
          </span>
          &nbsp; {isEdit ? "Cập nhật" : "Thêm mới"}
          &nbsp;
        </button>
        &nbsp;
        <a
          className="btn btn-new-main btn-closenew"
          data-dismiss="modal"
          href={() => false}
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>{" "}
          Đóng
        </a>
      </Modal.Footer>
    </Modal>
  );
};
